import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import SideMenu, { getVerticalSideMenuWidth } from './SideMenu/SideMenu';
import { LinearGradient } from '@cb/solaris-react/Constants/Colors';
import useInheritedTheme from '@cb/solaris-react/Hooks/UseInheritedTheme';
export function BlankPage(props) {
    return (_jsx(Page, { pageTitle: props.pageTitle, hideSideMenu: true, children: props.children }));
}
export default function Page(props) {
    const { hideSideMenu, raw, children, sideMenuLinksComponentGenerator, burgerMenuItems, secondaryBottomMenuItems, pageTitle, } = props;
    useEffect(() => {
        document.title = pageTitle ?? document.title;
    }, [pageTitle]);
    const theme = useInheritedTheme();
    if (raw) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs(StyledPageWrapper, { children: [!hideSideMenu ? (_jsx(StyledPageNav, { children: _jsx(SideMenu, { sideMenuLinksComponentGenerator: sideMenuLinksComponentGenerator, burgerMenuItems: burgerMenuItems, secondaryBottomItems: secondaryBottomMenuItems }) })) : null, _jsx(StyledPageContent, { "$sideMenuWidth": hideSideMenu ? '0' : getVerticalSideMenuWidth(theme), children: children })] }));
}
const StyledPageWrapper = styled.article `
	background: ${(props) => LinearGradient(135, props.theme.palette.shade7, props.theme.palette.shade6)};
	color: ${(props) => props.theme.schemes.primary.text};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	max-width: 100vw;
	min-height: 100vh;
	width: 100%;

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;
const StyledPageContent = styled.main `
	flex-grow: 1;
	z-index: 0;

	${(props) => props.theme.scrollbars.normal}

	background: transparent;
	flex-basis: 100%;

	// Force max width of page content
	max-width: calc(100vw - ${({ $sideMenuWidth }) => $sideMenuWidth});

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		max-width: 100vw;
	}
`;
const StyledPageNav = styled.nav `
	background-color: ${(props) => props.theme.primary};

	@media (max-width: ${(props) => props.theme.breakpoints.md}) {
		position: sticky;
		top: 0;
		z-index: 1;
	}
`;
//# sourceMappingURL=Page.js.map